import { render, staticRenderFns } from "./NotificationBtn.vue?vue&type=template&id=a34fff7c&"
import script from "./NotificationBtn.vue?vue&type=script&lang=ts&"
export * from "./NotificationBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports